export default {"src":"https://fishbrain.com/_next/static/media/alaska.0db64bf2.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};